'use strict';

export default class AddController {

  /*@ngInject*/
  constructor($http, $state, $scope, Upload, toaster) {
    this.$http = $http;
    this.$state = $state;
    this.$scope = $scope;
    this.Upload = Upload;
    this.toaster = toaster;

    this.newFirmware = {};
  }

  $onInit() {   
  }

  upload(file) {
    this.toaster.pop({
      type: 'wait',
      title: '正在上传，请稍等...',
      body: file.name,
      timeout: 3000 * 1000
    });

    file.upload = this.Upload.upload({
      url: '/api/monitors/uploadFile',
      file: file,
      data: this.newFirmware,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    file.upload.progress((evt) => {
      file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
    });

    file.upload.success((data, status, headers, config) => {
      this.toaster.clear();
      this.$state.go('monitor');
      this.toaster.pop('success', '上传成功', file.name);
    });

    file.upload.error((err) => {
      this.toaster.clear();
      this.toaster.pop('error', '上传失败', JSON.stringify(err));
    });
  }

}



// WEBPACK FOOTER //
// ./client/app/monitor/add/add.controller.js